import styled from "styled-components";

export const CustomSettingToggleStyled = styled.div`
.Polaris-Badge {
    margin-left: 4px;
}
`